import { Directive, ElementRef, Input,  OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedDataService } from '../../Services/shared-data/shared-data.service';
import { PS_Lib_Report_Et_Form_Result } from '../../all-models';
import { Observable, Subject } from 'rxjs';

@Directive({
  selector: '[paflabel]'
})
export class PafLabelDirective implements OnInit, OnChanges {
  @Input() paflabel: string = '';
  @Input() rescod: string = '';

  public labels: PS_Lib_Report_Et_Form_Result[] = [];

  constructor(
    public sharedDatasSvc: SharedDataService,
    private route?: ActivatedRoute,
    private el?: ElementRef) {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rescod'] || changes['paflabel']) this.updatelabel();
  }
  private labelsReloadedSubject = new Subject<PS_Lib_Report_Et_Form_Result[]>();
  public labelsReloaded = this.labelsReloadedSubject.asObservable();
  ngOnInit(): void {
      this.labels = this.sharedDatasSvc.labels;
      this.sharedDatasSvc.langChanged.subscribe((lngCod: string) => this.updatelabel());
      this.sharedDatasSvc.onLabelLoaded.subscribe(res=>this.updatelabel());
  }

  reloadLibs(): void {
    
      this.sharedDatasSvc.getLabels()
        .subscribe((results: PS_Lib_Report_Et_Form_Result[]) => {
          this.labels = results;
          this.labelsReloadedSubject.next(results);
          if (this.el) {
            let item: PS_Lib_Report_Et_Form_Result | undefined = results.find(t=>t.LblCod==this.paflabel);
            if (item?.LblLabel){
              this.el.nativeElement.innerHTML = item.LblLabel;
            } else {
              this.el.nativeElement.innerHTML = '??? '+(this.paflabel|| '' )+' ???';
            }
          }
        });
  }


  updatelabel():void{
    this.labels = this.sharedDatasSvc.labels;
    if (this.el) {
      let item: PS_Lib_Report_Et_Form_Result =(this.labels||[]).find(t=>t.LblCod==this.paflabel);
      if (item?.LblLabel){
        this.el.nativeElement.innerHTML = item.LblLabel;
      } else {
        this.el.nativeElement.innerHTML = '??? '+(this.paflabel|| '' )+' ???';
      }
    }
  }
  

  getLabel(lblCod?: string):  Observable<string> {
    return this.sharedDatasSvc.getLabel(lblCod|| this.paflabel || '');
  } 

  getLabelSync(lblCod: string):string {
    return (this.labels||[]).getPafLabel(lblCod);
  }


}


